import isV5ChartDef from './isV5ChartDef';

const isEntityInformationTable = (
  def: undefined | ExtendedVisualisationDefinition,
): def is VisualisationDefinitions.EntityInformationTable => {
  if (isV5ChartDef(def)) {
    return false;
  }

  return def !== undefined && def.type === 'EntityInformationTable';
};

export default isEntityInformationTable;
